import './ApiRequests.scss';
import { CHANGE_EVENT_PREFERENCES } from '@sonar-software/sonar-ts-constants';
import { InfoCircleOutlined } from '@ant-design/icons';
import { SonarText } from '@ui/text';
import { Progress, Tooltip } from 'antd';
import React, { ReactNode } from 'react';

export interface ApiRequestsProps {
	header: string;
	maxCalls: number;
	usedCalls: number;
	tooltip: string | ReactNode;
}

export const ApiRequests: React.FC<ApiRequestsProps> = ({ header, maxCalls, usedCalls, tooltip }) =>
	<div className='api-requests'>
		<SonarText className='api-header'>
			{ header }
			<Tooltip title={ tooltip }>
				<InfoCircleOutlined />
			</Tooltip>
		</SonarText>
		<div className='api-data'>
			<SonarText
				className='used-calls'
				size={ 20 }
				weight='semibold'>
				{ usedCalls.toLocaleString('en') }
			</SonarText>{ ' ' }
			<SonarText className='max-calls'>{ CHANGE_EVENT_PREFERENCES.OUT_OF(maxCalls) }</SonarText>
		</div>
		<Progress
			className='api-progress'
			percent={ Math.round((usedCalls / maxCalls) * 100) }
			size='small' />
	</div>;

